// extracted by mini-css-extract-plugin
module.exports = {"Margin":"Margin--lwMK2"};